export default __webpack_public_path__ + "static/media/our-dealer-bg.adc4993c.jpg";